/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type child_extras_ChildExtraResponse = {
    amountCents?: number;
    childId?: string;
    childName?: string;
    createdAt?: string;
    id?: string;
    internalComment?: string;
    invoiceId?: string;
    invoiceNumber?: string;
    parentComment?: string;
    serviceDate?: string;
    /**
     * Status is PENDING (not yet billed) or BILLED (stamped onto a finalized invoice).
     */
    status?: child_extras_ChildExtraResponse.status;
    type?: child_extras_ChildExtraResponse.type;
    updatedAt?: string;
};
export namespace child_extras_ChildExtraResponse {
    /**
     * Status is PENDING (not yet billed) or BILLED (stamped onto a finalized invoice).
     */
    export enum status {
        PENDING = 'PENDING',
        BILLED = 'BILLED',
    }
    export enum type {
        EINSCH = 'EINSCH',
        EMPFEHL = 'EMPFEHL',
        MISC = 'MISC',
        LEGACY = 'LEGACY',
        SETTLING_IN = 'SETTLING_IN',
        TERMINATION = 'TERMINATION',
    }
}

